import Image from 'next/image';
import { ITopInsightImageProps } from '@/molecules/00-ui/TopInsightImage/index.types';

export const TopInsightImage = ({ image, tags }: ITopInsightImageProps) => {
  return (
    <div className="relative w-full h-full">
      <div
        role="presentation"
        className="
          absolute
          top-[-142px] right-[-164px]
          bg-[url(/backgrounds/polygons-group-purple.svg)] w-[458px] h-[367px]
          bg-contain bg-center bg-no-repeat
          pointer-events-none
        "
      />
      {tags && (
        <div className="absolute inset-0 z-10 p-base w-full h-full">
          <ul className="flex flex-col gap-[10px] align-start">
            {tags.map(({ title }) => (
              // TODO: REPLACE WITH <CHIP /> (ATOM) COMPONENT AFTER IMPLEMENTATION
              <li
                key={title}
                className="self-start"
              >
                <div className="flex justify-center items-center px-[8px] py-[2px] rounded-full bg-purple-7 shring-0">
                  <span className="text-white leading-lg text-nowrap text-[12px]">{title}</span>
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
      {image && (
        <Image
          src={image?.src}
          alt={image.alt}
          width={image.width}
          height={image.height}
          className="w-full h-full object-cover"
        />
      )}
    </div>
  );
};
